import React, { useState, useEffect } from 'react';
import api from "../utils/apiClient";
import CarOverviewWithSaldo from './CarOverviewWithSaldo';
import AbonoModal from './AbonoCar';
import '../style/CarModal.css';

const CarModal = ({ userId, showModal, onClose }) => {
  const [cars, setCars] = useState([]);
  const [selectedCar, setSelectedCar] = useState(null); // Estado para el carro seleccionado

  useEffect(() => {
    if (showModal) {
      const fetchCars = async () => {
        try {
          const response = await api.post("ventas/comprasbyuser", { usuarioID: userId });
          setCars(response.data);
        } catch (error) {
          console.error("Error fetching cars:", error);
        }
      };
      fetchCars();
    }
  }, [showModal, userId]);

  const handleCarClick = (car) => {
    setSelectedCar(car);
  };

  const handleCloseAbonoModal = () => {
    setSelectedCar(null);
    onClose();
  };

  if (!showModal) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose} aria-label="Cerrar">×</button>
        <h2>Carros Comprados {cars.length > 0 && <span className="modal-count">({cars.length})</span>}</h2>
        <div className="cars-grid">
          {cars.length === 0 ? (
            <p className="cars-grid-empty">Sin carros comprados</p>
          ) : (
            cars.map(car => (
              <CarOverviewWithSaldo key={car._id} carro={car.Carro} saldo={car.Saldo} onClick={() => handleCarClick(car)} />
            ))
          )}
        </div>
      </div>
      {selectedCar && (
        <AbonoModal 
          show={!!selectedCar} 
          carro={selectedCar.Carro} 
          onClose={handleCloseAbonoModal} 
        />
      )}
    </div>
  );
};

export default CarModal;
